import React, { ChangeEvent, useEffect, useState } from 'react'
import './Policies.scss'
import Swal from 'sweetalert2'
import uploadDocumentService from 'Services/uploadDocumentService'
import { CloudUploadSvg } from 'Components/Svgs'
import { IPoliciesType } from 'Models'
import { useLocation } from 'react-router-dom'
import Trash from '../../../../Assets/Images/trash.png'
import { ModalWrapper } from 'Components'

const Policies = () => {
  const location = useLocation()
  const isAdminRoute = location.pathname.includes('/admin/policies')

  const [uploading, setUploading] = useState(false)
  const [policyType, setPolicyType] = useState<string>('')
  const [fileName, setFileName] = useState<string>('')
  const [selectedFile, setSelectedFile] = useState<File | null>(null)
  const [policiesTable, setPoliciesTable] = useState<IPoliciesType[]>([])

  const fetchAdminData = async () => {
    try {
      const res = await uploadDocumentService.adminGetAllPolicies()
      const dataset = res.data.data
      const normaliseData = Array.isArray(dataset) ? dataset : [dataset]
      setPoliciesTable(normaliseData)
    } catch (error: any) {
      console.log('err', error)
      Swal.hideLoading()
      Swal.fire({
        icon: 'warning',
        title: 'Oops!',
        text: error.response.data.error || 'Something went wrong',
        showConfirmButton: false,
        timer: 3000,
      })
    }
  }

  const fetchUsersData = async () => {
    try {
      const res = await uploadDocumentService.userGetAllPolicies()
      const dataset = res.data.data
      const normaliseData = Array.isArray(dataset) ? dataset : [dataset]
      setPoliciesTable(normaliseData)
    } catch (error: any) {
      console.log('err', error)
      Swal.hideLoading()
      Swal.fire({
        icon: 'warning',
        title: 'Oops!',
        text: error.response.data.error || 'Something went wrong',
        showConfirmButton: false,
        timer: 3000,
      })
    }
  }

  useEffect(() => {
    if (isAdminRoute) {
      fetchAdminData()
    } else {
      fetchUsersData()
    }
  }, [isAdminRoute])

  function resetFileInput() {
    const fileInput = document.getElementById('upload_file') as HTMLInputElement
    if (fileInput) {
      fileInput.value = '' // input reset
    }
  }

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] || null
    if (!file) return
    if (file.type !== 'application/pdf') {
      Swal.fire({
        icon: 'error',
        title: 'Oops!',
        text: 'Only PDF files are allowed',
        showConfirmButton: false,
      })
      e.target.value = ''
      setSelectedFile(null)
      return
    }
    setSelectedFile(file)
  }

  const handleUpload = async () => {
    if (!selectedFile || (!isCustom && !policyType) || (isCustom && !fileName)) {
      Swal.fire({
        icon: 'warning',
        title: 'Missing info',
        text: 'Please select both a file and a policy type.',
        showConfirmButton: false,
        timer: 3000,
      })
      return
    }

    if (selectedFile.type !== 'application/pdf') {
      Swal.fire({
        icon: 'error',
        title: 'Oops!',
        text: 'Only PDF files are allowed',
        showConfirmButton: false,
      })
      return
    }

    setUploading(true)

    const formData = new FormData()
    formData.append('file', selectedFile)

    const policy = isCustom ? 'others' : policyType
    const isFileNameOveride = isCustom ? fileName : policyType

    // console.log({
    //   policy,
    //   isFileNameOveride,
    //   isCustom,
    // })

    await uploadDocumentService.policies(policy, formData, isFileNameOveride).then(
      (res: any) => {
        setUploading(false)
        setSelectedFile(null)
        // console.log('policiesTable', res)
        if (res.data.status === true) {
          fetchAdminData()
          Swal.fire({
            icon: 'success',
            text: 'Policy uploaded successfully',
            showConfirmButton: false,
            timer: 3000,
          })
          resetFileInput()
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Oops!',
            text: 'Upload failed',
            showConfirmButton: false,
            timer: 3000,
          })
        }
      },
      (error) => {
        setUploading(false)
        Swal.fire({
          icon: 'error',
          title: 'Oops!',
          text: error.response?.data?.error || 'Upload failed',
          showConfirmButton: false,
          timer: 3000,
        })
      },
    )
  }

  const handleCancelFile = () => {
    setSelectedFile(null)
    resetFileInput()
  }

  const [loading, setLoading] = useState<boolean>(false)
  const [policy, setPolicy] = useState<string>('')
  const [showPolicyModal, setShowPolicyModal] = useState(false)
  const [isCustom, setIsCustom] = useState(false)

  const togglePolicyModal = () => {
    setShowPolicyModal((prevState) => !prevState)
  }

  const handlePolicyDelete = async (policyType: string) => {
    setLoading(true)
    try {
      const res = await uploadDocumentService.adminDeletePolicy(policyType)

      if (res.data.status === true) {
        setPoliciesTable((prev) => prev.filter((p) => p.policyType !== policyType))
        setShowPolicyModal(false)
        setPolicyType('')
        setFileName('')
        setSelectedFile(null)
        resetFileInput()
      } else {
        Swal.fire({
          icon: 'warning',
          title: 'Oops!',
          text: 'Something went wrong',
          showConfirmButton: false,
          timer: 3000,
        })
      }
    } catch (error: any) {
      // console.error('Delete failed', error)
      Swal.hideLoading()
      Swal.fire({
        icon: 'warning',
        title: 'Oops!',
        text: error.response.data.error || 'Something went wrong',
        showConfirmButton: false,
        timer: 3000,
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className='PoliciesComp'>
      <div className='card-body row custom-card'>
        <div className='card px-md-4 border-0 shadow-sm'>
          <div className='card-body'>
            <div className='card-header row'>Policies</div>
            {isAdminRoute && (
              <div className='row align-items-center border rounded p-3 mt-3 bg-white shadow-sm'>
                <div className='col-md-4 mb-2 mb-md-0'>
                  <button
                    className='btn btn-upload-photo d-flex align-items-center gap-2'
                    type='button'
                    onClick={() => document.getElementById('upload_file')?.click()}
                  >
                    <CloudUploadSvg />
                    <span>Select File in pdf format</span>
                  </button>
                  <input
                    type='file'
                    id='upload_file'
                    className='d-none'
                    accept='.pdf,application/pdf'
                    onChange={handleFileChange}
                  />
                  {selectedFile && (
                    <div className='d-flex align-items-center mt-2'>
                      <span className='small text-muted me-2'>{selectedFile.name}</span>
                      <button
                        type='button'
                        className='btn btn-sm  py-0 px-2'
                        onClick={handleCancelFile}
                      >
                        ✕
                      </button>
                    </div>
                  )}{' '}
                </div>

                <div className='col-md-4 mb-2 mb-md-0'>
                  <label htmlFor='policyType' className='form-label fw-semibold mb-1'>
                    Policy Type
                  </label>
                  {!isCustom ? (
                    <select
                      className='form-select'
                      id='policyType'
                      value={policyType}
                      onChange={(e) => {
                        const value = e.target.value
                        if (value === 'other') {
                          setPolicyType('')
                          setFileName('')
                          setIsCustom(true)
                        } else {
                          setPolicyType(e.target.value)
                        }
                      }}
                    >
                      <option value='' disabled hidden>
                        Select option
                      </option>
                      <option value='performance_management'>Performance Mgt</option>
                      <option value='loan'>Loan</option>
                      <option value='medical_insurance'>Medical Insurance</option>
                      <option value='leave'>Leave</option>
                      <option value='procurement'>Procurement</option>
                      <option value='cybersecurity'>Cybersecurity</option>
                      <option value='travel'>Travel</option>
                      <option value='aml_cft'>AML & CFT</option>
                      <option value='tg_privacy'>TG Privacy Policy</option>
                      <option value='operating_model'>Operating Model</option>
                      <option value='financial_approval'>Financial Approval</option>
                      <option value='e_s'>E & S Policy</option>
                      <option value='credit'>Credit</option>
                      <option value='employee_handbook'>Employee Handbook</option>
                      <option value='relocation_mobility'>Relocation Mobility</option>
                      <option value='training'>Training</option>
                      <option value='secondment'>Secondment</option>
                      <option value='other'>Other (manual)</option>
                    </select>
                  ) : (
                    <div className='position-relative'>
                      <input
                        type='text'
                        className='form-control pe-5'
                        placeholder='Enter policy type'
                        value={fileName}
                        onChange={(e) => setFileName(e.target.value)}
                        autoFocus
                      />

                      <button
                        type='button'
                        className='btn btn-sm btn-outline-secondary position-absolute top-50 end-0 translate-middle-y me-1'
                        onClick={() => {
                          setIsCustom(false)
                          setPolicyType('')
                          setFileName('')
                        }}
                        title='Go back to list'
                      >
                        ←
                      </button>
                    </div>
                  )}
                </div>

                <div className='col-md-4 text-end'>
                  <button
                    className='btn btn-request px-4'
                    type='button'
                    disabled={
                      uploading ||
                      !selectedFile ||
                      (!isCustom && !policyType) ||
                      (isCustom && !fileName)
                    }
                    onClick={handleUpload}
                  >
                    {uploading ? (
                      <span className='spinner-border spinner-border-sm'></span>
                    ) : (
                      'Upload Policy'
                    )}
                  </button>
                </div>
              </div>
            )}

            <div className='row mt-3'>
              {policiesTable.map((policy) => (
                <div key={policy.id} className='col-md-6 mb-3'>
                  {policy.document?.url ? (
                    <div className='policy-wrapper'>
                      <a
                        href={policy.document.url}
                        target='_blank'
                        rel='noopener noreferrer'
                        className='policy-link'
                      >
                        {policy.documentName !== null ? policy.documentName : policy.policyType}
                      </a>
                      {isAdminRoute && (
                        <button
                          className='delete-policy-btn'
                          onClick={() => {
                            setPolicy(policy.policyType)
                            setShowPolicyModal(true)
                          }}
                          title='Delete policy'
                        >
                          <img src={Trash} alt='delete' className='delete-policy' />
                        </button>
                      )}
                    </div>
                  ) : (
                    <span className='text-muted policy-link-disabled'>
                      {policy.policyType} (No document)
                    </span>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <ModalWrapper
        showModal={showPolicyModal}
        closeModal={togglePolicyModal}
        title='Policy Removal'
      >
        <p>
          You&apos;re about to delete <strong>{policy}</strong> policy. Would you like to continue?
        </p>

        <div className='d-flex'>
          <button
            className='btn btn-default mt-3 ms-auto me-3'
            onClick={() => handlePolicyDelete(policy)}
          >
            Yes {loading && <span className='spinner-border spinner-border-sm ms-2'></span>}
          </button>
        </div>
      </ModalWrapper>
    </div>
  )
}

export default Policies
